import React from 'react';
import PropTypes from 'prop-types';
import Flux  from '../../../flux/Flux';
import style from './ActorProfileFeedback.module.less';
import Headline from '../../SimpleElements/Headline';
import Translations from "../../../utils/Translations";
import ActorProfileFeedbackListItem from './ActorProfileFeedbackListItem';


const ActorProfileFeedback = (props) => {
    const {albumId, editable, actor} = props;
    const [isLoading, setIsLoading] = React.useState(true);
    const [items, setItems] = React.useState([]);
    const [total, setTotal] = React.useState(0);
    const [isEditable, setIsEditable] = React.useState(editable);
    const [showAll, setShowAll] = React.useState(false);
    const [isCommentValid, setIsCommentValid] = React.useState(false);
    const [showError, setShowError] = React.useState(false);

    const onCommentsChange = (id) => {
        const data = Flux.Gallery.getCommentsData(id);
        if (data) {
            setTotal(data.commentsTotal);
            setItems(data.comments);
            setIsEditable(data.isGuestAllowedToCommentAlbum);
            setIsLoading(false);
        }
    };

    React.useEffect(() => {
            Flux.Gallery.addCommentsChangeListener(onCommentsChange);
            Flux.Gallery.showMoreComments(albumId);
            return () => {
                Flux.Gallery.removeCommentsChangeListener(onCommentsChange);
            };
    }, [albumId]);

    if (isLoading) {
        return null;
    }

    const getFeedbacks = (feedbacks) => {
        if (feedbacks.length === 0) {
            return null;
        }
        if (feedbacks.length === 1 || !showAll) {
            return <ul className={style['feedback__list']}><ActorProfileFeedbackListItem item={feedbacks[0]} actor={actor} /></ul>;
        }
        return <ul className={style['feedback__list']}>
            { items.map((item, index) => <ActorProfileFeedbackListItem key={index} item={item} actor={actor} />) }
        </ul>;
    };

    const getShowMoreButton = (total) => {
        if (total < 2 ) {
            return null;
        }
        return <div className={style[`feedback__show-more`]} onClick={() => setShowAll(!showAll)}>
            {showAll ? `Weniger anzeigen` : `Zeige ${total - 1} Kommentare`}
        </div>;
    };

    const submitForm = (e) => {
        setShowError(true);
        e.preventDefault();
        if (!isCommentValid) {
            return;
        }
        const value   = e.target.elements["feedback-input"].value;
        const comment = value.trim();
        e.target.elements["feedback-input"].value = '';

        if (albumId) {
          Flux.Gallery.addComment(albumId, comment);
          setIsEditable(false);
        }
    };

    const onInputChange = (e) => {
        const value = e.target.value;
        const commentLength = value.trim().length;
        const commentValid  = commentLength >= 1 && commentLength <= 1000;
        setIsCommentValid(commentValid);
        setShowError(!commentValid);
    };

    const getInputForm = () => {
        return <div className={`${style['feedback__form-container']} ${items.length === 0 ? style['feedback__form-container--no-feedbacks'] : ''}`}>
            <img src={guestImage} alt="Guest" className={style[`feedback__list-item__image`]} />
            {Flux.Guest.isBlockedForComments() && <div className={style['feedback__form-blocked']}>{Translations.get('common.blocked-for-comments')}</div>}
            {!Flux.Guest.isBlockedForComments() && <form className={style['feedback__form']} onSubmit={submitForm}>
                <label className={style['feedback__form-label']} htmlFor="feedback-input">
                    <input className={style['feedback__form-input']} type="text" name="feedback-input" placeholder={Translations.get('FeedbackInputPlaceholder')} onChange={onInputChange} min="1" max="1000"></input>
                    {showError && <div className={style['feedback__form-error']}>{Translations.get('FeedbackInputMaxLimit')}</div>}
                </label>
                <button className={`icon -icon-send-chat-full ${style['feedback__form-button']}`} type="submit" disabled={!isCommentValid}></button>
            </form>}
        </div>;
    };

    const guestImage = Flux.Guest.getGuestUrlPreviewPicture();
    return (
        <div className={style[`feedback__container`]}>
            <Headline title={Translations.get("Feedbacks")} transparent class="vxheadline--no-grid" />
            <div className={style['feedback']}>
                {getFeedbacks(items)}
                {getShowMoreButton(total)}
                {isEditable && getInputForm()}
            </div>
        </div>
    );
};

ActorProfileFeedback.propTypes = {
    albumId:  PropTypes.number.isRequired,
    editable: PropTypes.bool,
    actor:  PropTypes.object,
};

export default ActorProfileFeedback;
